import React from 'react';

import {
  Flex, Text, TabList, Tab,
} from '@chakra-ui/react';

import DateRange from 'containers/Dashboard/Filter';

const sections = [
  { label: 'Informações Gerais' },
  { label: 'Status de Atividades' },
];
function Section() {
  return (
    <Flex
      borderBottom="2px"
      borderColor="gray.150"
      flex={1}>
      <TabList
        borderBottom="none">
        {sections.map(({ label }, index) => (
          <Tab
            color="gray.400"
            _selected={{ color: 'gray.600', borderBottom: '2px', borderColor: 'primary.default' }}
            key={`header-${label}-${index}`}>
            <Text
              variant="smallBold">{label}
            </Text>
          </Tab>
        ))}
      </TabList>
    </Flex>
  );
}

export default function DashboardHeader({
  range,
  setRange,
}) {
  return (
    <Flex
      width="100%">
      <Section />
      <DateRange
        range={range}
        setRange={setRange}
      />
    </Flex>
  );
}
